import ISpineAnimConfig from '../../vendor_core/core/src/managers/contracts/configurations/spine_anim/ISpineAnimConfig';
import AbstractBaseSpineAnimationsConfig from '../../vendor_core/core/src/baseConfigs/AbstractSceneSpineAnimationsConfig';
import ISceneSpineAnimConfig from '../../vendor_core/core/src/managers/contracts/configurations/ISceneSpineAnimConfig';

class SpineAnimationsConfig extends AbstractBaseSpineAnimationsConfig implements ISceneSpineAnimConfig {
    anims: ISpineAnimConfig[] = [
        {
            name: "bigWin",
            hasSkins: false,
            states: [
                {
                    name: "bigwin_loop",
                    loop: false
                },
                {
                    name: "bigwin_end",
                    loop: false
                },
                {
                    name: "superwin_loop",
                    loop: false
                },
                {
                    name: "superwin_end",
                    loop: false
                },
                {
                    name: "megawin_loop",
                    loop: false
                },
                {
                    name: "megawin_end",
                    loop: false
                },
                {
                    name: "epicwin_loop",
                    loop: false
                },
                {
                    name: "epicwin_end",
                    loop: false
                }
            ],
            visible: false,
            defaultState: "bigwin_anim",
            playDefault: false,
            forceRepositionContainer: false,
        },
        {
            name: "collect",
            hasSkins: false,
            states: [
                {
                    name: "reel_1_1",
                    loop: false
                },
                {
                    name: "reel_1_2",
                    loop: false
                },
                {
                    name: "reel_1_3",
                    loop: false
                },
                {
                    name: "reel_1_4",
                    loop: false
                },
                {
                    name: "reel_1_5",
                    loop: false
                },
                {
                    name: "reel_2_1",
                    loop: false
                },
                {
                    name: "reel_2_2",
                    loop: false
                },
                {
                    name: "reel_2_3",
                    loop: false
                },
                {
                    name: "reel_2_4",
                    loop: false
                },
                {
                    name: "reel_2_5",
                    loop: false
                },
                {
                    name: "reel_3_1",
                    loop: false
                },
                {
                    name: "reel_3_2",
                    loop: false
                },
                {
                    name: "reel_3_3",
                    loop: false
                },
                {
                    name: "reel_3_4",
                    loop: false
                },
                {
                    name: "reel_3_5",
                    loop: false
                },
                {
                    name: "reel_4_1",
                    loop: false
                },
                {
                    name: "reel_4_2",
                    loop: false
                },
                {
                    name: "reel_4_3",
                    loop: false
                },
                {
                    name: "reel_4_4",
                    loop: false
                },
                {
                    name: "reel_4_5",
                    loop: false
                },
                {
                    name: "reel_5_1",
                    loop: false
                },
                {
                    name: "reel_5_2",
                    loop: false
                },
                {
                    name: "reel_5_3",
                    loop: false
                },
                {
                    name: "reel_5_4",
                    loop: false
                },
                {
                    name: "reel_5_5",
                    loop: false
                },
                {
                    name: "reel_6_1",
                    loop: false
                },
                {
                    name: "reel_6_2",
                    loop: false
                },
                {
                    name: "reel_6_3",
                    loop: false
                },
                {
                    name: "reel_6_4",
                    loop: false
                },
                {
                    name: "reel_6_5",
                    loop: false,
                },
            ],
            containerSize: 1.5,
            visible: true,
            defaultState: "reel_1_4",
            playDefault: false,
            forceRepositionContainer: false,
        },
        {
            name: "collection",
            hasSkins: false,
            states: [
                {
                    name: "end",
                    loop: false
                },
                {
                    name: "loop",
                    loop: false
                },
                {
                    name: "start",
                    loop: false
                },
                {
                    name: "win",
                    loop: false
                },
            ],
            containerSize: 1.5,
            visible: false,
            defaultState: "loop",
            playDefault: false,
            forceRepositionContainer: false,
        },
        {
            name: "rain",
            hasSkins: false,
            states: [
                {
                    name: "coins_falling",
                    loop: false
                },
                {
                    name: "coin_flip",
                    loop: true
                },
            ],
            containerSize: 1.2,
            visible: true,
            defaultState: "coins_falling",
            playDefault: true,
            // forceRepositionContainer: false,
        },
        {
            name: "chest",
            hasSkins: false,
            states: [
                {
                    name: "st_0_loop",
                    loop: true
                },
                {
                    name: "st_0_to_st_1",
                    loop: false
                },
                {
                    name: "st_0_coin",
                    loop: false
                },
                {
                    name: "st_0_coin_rain",
                    loop: false
                },
                {
                    name: "st_1_coin",
                    loop: false
                },
                {
                    name: "st_1_coin_rain",
                    loop: false
                },
                {
                    name: "st_1_loop",
                    loop: true
                },
                {
                    name: "st_1_to_st_2",
                    loop: false
                },
                {
                    name: "st_2_coin",
                    loop: false
                },
                {
                    name: "st_2_coin_rain",
                    loop: false
                },
                {
                    name: "st_2_loop",
                    loop: true
                },
                {
                    name: "st_2_to_st_3",
                    loop: false
                },
                {
                    name: "st_3_coin",
                    loop: false
                },
                {
                    name: "st_3_coin_rain",
                    loop: false
                },
                {
                    name: "st_3_loop",
                    loop: true
                },
                {
                    name: "st_3_to_st_4",
                    loop: false
                },
                {
                    name: "st_4_coin",
                    loop: false
                },
                {
                    name: "st_4_coin_rain",
                    loop: false
                },
                {
                    name: "st_4_loop",
                    loop: true
                },
                {
                    name: "st_4_to_st_5",
                    loop: false
                },
                {
                    name: "st_5_coin",
                    loop: false
                },
                {
                    name: "st_5_coin_rain",
                    loop: false
                },
                {
                    name: "st_5_loop",
                    loop: true
                },
                {
                    name: "st_5_to_st_6",
                    loop: false
                },
                {
                    name: "st_6_coin",
                    loop: false
                },
                {
                    name: "st_6_coin_rain",
                    loop: false
                },
                {
                    name: "st_6_loop",
                    loop: true
                },
                {
                    name: "st_6_to_st_7",
                    loop: false
                },
                {
                    name: "st_7_coin",
                    loop: false
                },
                {
                    name: "st_7_coin_rain",
                    loop: false
                },
                {
                    name: "st_7_loop",
                    loop: true
                },
                {
                    name: "st_7_to_st_8",
                    loop: false
                },
                {
                    name: "st_8_coin",
                    loop: false
                },
                {
                    name: "st_8_coin_rain",
                    loop: false
                },
                {
                    name: "st_8_loop",
                    loop: true
                },
                {
                    name: "st_8_to_st_9",
                    loop: false
                },
                {
                    name: "st_9_coin",
                    loop: false
                },
                {
                    name: "st_9_coin_rain",
                    loop: false
                },
                {
                    name: "st_9_loop",
                    loop: true
                },
                {
                    name: "st_9_to_st_10",
                    loop: false
                },
                {
                    name: "st_10_coin",
                    loop: false
                },
                {
                    name: "st_10_coin_rain",
                    loop: false
                },
                {
                    name: "st_10_loop",
                    loop: true
                },
                {
                    name: "st_10_to_st_11",
                    loop: false
                },
                {
                    name: "st_11_coin",
                    loop: false
                },
                {
                    name: "st_11_coin_rain",
                    loop: false
                },
                {
                    name: "st_11_loop",
                    loop: true
                },
                {
                    name: "st_11_to_st_12",
                    loop: false
                },
                {
                    name: "st_12_coin",
                    loop: false
                },
                {
                    name: "st_12_coin_rain",
                    loop: false
                },
                {
                    name: "st_12_loop",
                    loop: true
                },
                {
                    name: "st_12_to_st_13",
                    loop: false
                },
                {
                    name: "st_13_coin",
                    loop: false
                },
                {
                    name: "st_13_coin_rain",
                    loop: false
                },
                {
                    name: "st_13_loop",
                    loop: true
                },
                {
                    name: "st_13_to_st_14",
                    loop: false
                },
                {
                    name: "st_14_coin",
                    loop: false
                },
                {
                    name: "st_14_coin_rain",
                    loop: false
                },
                {
                    name: "st_14_loop",
                    loop: true
                },
                {
                    name: "st_14_to_st_15",
                    loop: false
                },
                {
                    name: "st_15_coin",
                    loop: false
                },
                {
                    name: "st_15_coin_rain",
                    loop: false
                },
                {
                    name: "st_15_loop",
                    loop: true
                },
                {
                    name: "st_15_to_st_16",
                    loop: false
                },
                {
                    name: "st_16_coin",
                    loop: false
                },
                {
                    name: "st_16_coin_rain",
                    loop: false
                },
                {
                    name: "st_16_loop",
                    loop: true
                },
            ],
            // containerSize: 1.5,
            visible: true,
            defaultState: "st_0_loop",
            playDefault: true,
            // forceRepositionContainer: false,
            chainingStates: [
                {
                    name: "transition_1",
                    entryPoint: "st_0_to_st_1",
                    hasLoopStateOnComplete: true,
                    hasStaticStateOnComplete: false,
                    hideOnComplete: false,
                    loopStateOnComplete: "st_1_loop",
                    loop: false,
                    states: ["st_0_to_st_1", "st_1_loop"]
                },
                {
                    name: "transition_2",
                    entryPoint: "st_1_to_st_2",
                    hasLoopStateOnComplete: true,
                    hasStaticStateOnComplete: false,
                    hideOnComplete: false,
                    loopStateOnComplete: "st_2_loop",
                    loop: false,
                    states: ["st_1_to_st_2", "st_2_loop"]
                },
                {
                    name: "transition_3",
                    entryPoint: "st_2_to_st_3",
                    hasLoopStateOnComplete: true,
                    hasStaticStateOnComplete: false,
                    hideOnComplete: false,
                    loopStateOnComplete: "st_3_loop",
                    loop: false,
                    states: ["st_2_to_st_3", "st_3_loop"]
                },
                {
                    name: "transition_4",
                    entryPoint: "st_3_to_st_4",
                    hasLoopStateOnComplete: true,
                    hasStaticStateOnComplete: false,
                    hideOnComplete: false,
                    loopStateOnComplete: "st_4_loop",
                    loop: false,
                    states: ["st_3_to_st_4", "st_4_loop"]
                },
                {
                    name: "transition_5",
                    entryPoint: "st_4_to_st_5",
                    hasLoopStateOnComplete: true,
                    hasStaticStateOnComplete: false,
                    hideOnComplete: false,
                    loopStateOnComplete: "st_5_loop",
                    loop: false,
                    states: ["st_4_to_st_5", "st_5_loop"]
                },
                {
                    name: "transition_6",
                    entryPoint: "st_5_to_st_6",
                    hasLoopStateOnComplete: true,
                    hasStaticStateOnComplete: false,
                    hideOnComplete: false,
                    loopStateOnComplete: "st_6_loop",
                    loop: false,
                    states: ["st_5_to_st_6", "st_6_loop"]
                },
                {
                    name: "transition_7",
                    entryPoint: "st_6_to_st_7",
                    hasLoopStateOnComplete: true,
                    hasStaticStateOnComplete: false,
                    hideOnComplete: false,
                    loopStateOnComplete: "st_7_loop",
                    loop: false,
                    states: ["st_6_to_st_7", "st_7_loop"]
                },
                {
                    name: "transition_8",
                    entryPoint: "st_7_to_st_8",
                    hasLoopStateOnComplete: true,
                    hasStaticStateOnComplete: false,
                    hideOnComplete: false,
                    loopStateOnComplete: "st_8_loop",
                    loop: false,
                    states: ["st_7_to_st_8", "st_8_loop"]
                },
                {
                    name: "transition_9",
                    entryPoint: "st_8_to_st_9",
                    hasLoopStateOnComplete: true,
                    hasStaticStateOnComplete: false,
                    hideOnComplete: false,
                    loopStateOnComplete: "st_9_loop",
                    loop: false,
                    states: ["st_8_to_st_9", "st_9_loop"]
                },
                {
                    name: "transition_10",
                    entryPoint: "st_9_to_st_10",
                    hasLoopStateOnComplete: true,
                    hasStaticStateOnComplete: false,
                    hideOnComplete: false,
                    loopStateOnComplete: "st_10_loop",
                    loop: false,
                    states: ["st_9_to_st_10", "st_10_loop"]
                },
                {
                    name: "transition_11",
                    entryPoint: "st_10_to_st_11",
                    hasLoopStateOnComplete: true,
                    hasStaticStateOnComplete: false,
                    hideOnComplete: false,
                    loopStateOnComplete: "st_11_loop",
                    loop: false,
                    states: ["st_10_to_st_11", "st_11_loop"]
                },
                {
                    name: "transition_12",
                    entryPoint: "st_11_to_st_12",
                    hasLoopStateOnComplete: true,
                    hasStaticStateOnComplete: false,
                    hideOnComplete: false,
                    loopStateOnComplete: "st_12_loop",
                    loop: false,
                    states: ["st_11_to_st_12", "st_12_loop"]
                },
                {
                    name: "transition_13",
                    entryPoint: "st_12_to_st_13",
                    hasLoopStateOnComplete: true,
                    hasStaticStateOnComplete: false,
                    hideOnComplete: false,
                    loopStateOnComplete: "st_13_loop",
                    loop: false,
                    states: ["st_12_to_st_13", "st_13_loop"]
                },
                {
                    name: "transition_14",
                    entryPoint: "st_13_to_st_14",
                    hasLoopStateOnComplete: true,
                    hasStaticStateOnComplete: false,
                    hideOnComplete: false,
                    loopStateOnComplete: "st_14_loop",
                    loop: false,
                    states: ["st_13_to_st_14", "st_14_loop"]
                },
                {
                    name: "transition_15",
                    entryPoint: "st_14_to_st_15",
                    hasLoopStateOnComplete: true,
                    hasStaticStateOnComplete: false,
                    hideOnComplete: false,
                    loopStateOnComplete: "st_15_loop",
                    loop: false,
                    states: ["st_14_to_st_15", "st_15_loop"]
                },
                {
                    name: "transition_16",
                    entryPoint: "st_15_to_st_16",
                    hasLoopStateOnComplete: true,
                    hasStaticStateOnComplete: false,
                    hideOnComplete: false,
                    loopStateOnComplete: "st_16_loop",
                    loop: false,
                    states: ["st_15_to_st_16", "st_16_loop"]
                },

                {
                    name: "collection_0",
                    entryPoint: "st_0_coin",
                    hasLoopStateOnComplete: true,
                    hasStaticStateOnComplete: false,
                    hideOnComplete: false,
                    loopStateOnComplete: "st_0_loop",
                    loop: false,
                    states: ["st_0_coin", "st_0_loop"]
                },
                {
                    name: "collection_1",
                    entryPoint: "st_1_coin",
                    hasLoopStateOnComplete: true,
                    hasStaticStateOnComplete: false,
                    hideOnComplete: false,
                    loopStateOnComplete: "st_1_loop",
                    loop: false,
                    states: ["st_1_coin", "st_1_loop"]
                },
                {
                    name: "collection_2",
                    entryPoint: "st_2_coin",
                    hasLoopStateOnComplete: true,
                    hasStaticStateOnComplete: false,
                    hideOnComplete: false,
                    loopStateOnComplete: "st_2_loop",
                    loop: false,
                    states: ["st_2_coin", "st_2_loop"]
                },
                {
                    name: "collection_3",
                    entryPoint: "st_3_coin",
                    hasLoopStateOnComplete: true,
                    hasStaticStateOnComplete: false,
                    hideOnComplete: false,
                    loopStateOnComplete: "st_3_loop",
                    loop: false,
                    states: ["st_3_coin", "st_3_loop"]
                },
                {
                    name: "collection_4",
                    entryPoint: "st_4_coin",
                    hasLoopStateOnComplete: true,
                    hasStaticStateOnComplete: false,
                    hideOnComplete: false,
                    loopStateOnComplete: "st_4_loop",
                    loop: false,
                    states: ["st_4_coin", "st_4_loop"]
                },
                {
                    name: "collection_5",
                    entryPoint: "st_5_coin",
                    hasLoopStateOnComplete: true,
                    hasStaticStateOnComplete: false,
                    hideOnComplete: false,
                    loopStateOnComplete: "st_5_loop",
                    loop: false,
                    states: ["st_5_coin", "st_5_loop"]
                },
                {
                    name: "collection_6",
                    entryPoint: "st_6_coin",
                    hasLoopStateOnComplete: true,
                    hasStaticStateOnComplete: false,
                    hideOnComplete: false,
                    loopStateOnComplete: "st_6_loop",
                    loop: false,
                    states: ["st_6_coin", "st_6_loop"]
                },
                {
                    name: "collection_7",
                    entryPoint: "st_7_coin",
                    hasLoopStateOnComplete: true,
                    hasStaticStateOnComplete: false,
                    hideOnComplete: false,
                    loopStateOnComplete: "st_7_loop",
                    loop: false,
                    states: ["st_7_coin", "st_7_loop"]
                },
                {
                    name: "collection_8",
                    entryPoint: "st_8_coin",
                    hasLoopStateOnComplete: true,
                    hasStaticStateOnComplete: false,
                    hideOnComplete: false,
                    loopStateOnComplete: "st_8_loop",
                    loop: false,
                    states: ["st_8_coin", "st_8_loop"]
                },
                {
                    name: "collection_9",
                    entryPoint: "st_9_coin",
                    hasLoopStateOnComplete: true,
                    hasStaticStateOnComplete: false,
                    hideOnComplete: false,
                    loopStateOnComplete: "st_9_loop",
                    loop: false,
                    states: ["st_9_coin", "st_9_loop"]
                },
                {
                    name: "collection_10",
                    entryPoint: "st_10_coin",
                    hasLoopStateOnComplete: true,
                    hasStaticStateOnComplete: false,
                    hideOnComplete: false,
                    loopStateOnComplete: "st_10_loop",
                    loop: false,
                    states: ["st_10_coin", "st_10_loop"]
                },
                {
                    name: "collection_11",
                    entryPoint: "st_11_coin",
                    hasLoopStateOnComplete: true,
                    hasStaticStateOnComplete: false,
                    hideOnComplete: false,
                    loopStateOnComplete: "st_11_loop",
                    loop: false,
                    states: ["st_11_coin", "st_11_loop"]
                },
                {
                    name: "collection_12",
                    entryPoint: "st_12_coin",
                    hasLoopStateOnComplete: true,
                    hasStaticStateOnComplete: false,
                    hideOnComplete: false,
                    loopStateOnComplete: "st_12_loop",
                    loop: false,
                    states: ["st_12_coin", "st_12_loop"]
                },
                {
                    name: "collection_13",
                    entryPoint: "st_13_coin",
                    hasLoopStateOnComplete: true,
                    hasStaticStateOnComplete: false,
                    hideOnComplete: false,
                    loopStateOnComplete: "st_13_loop",
                    loop: false,
                    states: ["st_13_coin", "st_13_loop"]
                },
                {
                    name: "collection_14",
                    entryPoint: "st_14_coin",
                    hasLoopStateOnComplete: true,
                    hasStaticStateOnComplete: false,
                    hideOnComplete: false,
                    loopStateOnComplete: "st_14_loop",
                    loop: false,
                    states: ["st_14_coin", "st_14_loop"]
                },
                {
                    name: "collection_15",
                    entryPoint: "st_15_coin",
                    hasLoopStateOnComplete: true,
                    hasStaticStateOnComplete: false,
                    hideOnComplete: false,
                    loopStateOnComplete: "st_15_loop",
                    loop: false,
                    states: ["st_15_coin", "st_15_loop"]
                },
                {
                    name: "collection_16",
                    entryPoint: "st_16_coin",
                    hasLoopStateOnComplete: true,
                    hasStaticStateOnComplete: false,
                    hideOnComplete: false,
                    loopStateOnComplete: "st_16_loop",
                    loop: false,
                    states: ["st_16_coin", "st_16_loop"]
                },
            ]
        },
        {
            name: "chestCoins",
            hasSkins: false,
            states: [
                {
                    name: "c_st_1_to_st_2",
                    loop: false
                },
                {
                    name: "c_st_2_coin",
                    loop: false
                },
                {
                    name: "c_st_2_coin_rain",
                    loop: false
                },
                {
                    name: "c_st_2_loop",
                    loop: true
                },
                {
                    name: "c_st_2_to_st_3",
                    loop: false
                },
                {
                    name: "c_st_3_coin",
                    loop: false
                },
                {
                    name: "c_st_3_coin_rain",
                    loop: false
                },
                {
                    name: "c_st_3_loop",
                    loop: true
                },
                {
                    name: "c_st_3_to_st_4",
                    loop: false
                },
                {
                    name: "c_st_4_coin",
                    loop: false
                },
                {
                    name: "c_st_4_coin_rain",
                    loop: false
                },
                {
                    name: "c_st_4_loop",
                    loop: true
                },
                {
                    name: "c_st_4_to_st_5",
                    loop: false
                },
                {
                    name: "c_st_5_coin",
                    loop: false
                },
                {
                    name: "c_st_5_coin_rain",
                    loop: false
                },
                {
                    name: "c_st_5_loop",
                    loop: true
                },
                {
                    name: "c_st_5_to_st_6",
                    loop: false
                },
                {
                    name: "c_st_6_coin",
                    loop: false
                },
                {
                    name: "c_st_6_coin_rain",
                    loop: false
                },
                {
                    name: "c_st_6_loop",
                    loop: true
                },
                {
                    name: "c_st_6_to_st_7",
                    loop: false
                },
                {
                    name: "c_st_7_coin",
                    loop: false
                },
                {
                    name: "c_st_7_coin_rain",
                    loop: false
                },
                {
                    name: "c_st_7_loop",
                    loop: true
                },
                {
                    name: "c_st_7_to_st_8",
                    loop: false
                },
                {
                    name: "c_st_8_coin",
                    loop: false
                },
                {
                    name: "c_st_8_coin_rain",
                    loop: false
                },
                {
                    name: "c_st_8_loop",
                    loop: true
                },
                {
                    name: "c_st_8_to_st_9",
                    loop: false
                },
                {
                    name: "c_st_9_coin",
                    loop: false
                },
                {
                    name: "c_st_9_coin_rain",
                    loop: false
                },
                {
                    name: "c_st_9_loop",
                    loop: true
                },
                {
                    name: "c_st_9_to_st_10",
                    loop: false
                },
                {
                    name: "c_st_10_coin",
                    loop: false
                },
                {
                    name: "c_st_10_coin_rain",
                    loop: false
                },
                {
                    name: "c_st_10_loop",
                    loop: true
                },
                {
                    name: "c_st_10_to_st_11",
                    loop: false
                },
                {
                    name: "c_st_11_coin",
                    loop: false
                },
                {
                    name: "c_st_11_coin_rain",
                    loop: false
                },
                {
                    name: "c_st_11_loop",
                    loop: true
                },
                {
                    name: "c_st_11_to_st_12",
                    loop: false
                },
                {
                    name: "c_st_12_coin",
                    loop: false
                },
                {
                    name: "c_st_12_coin_rain",
                    loop: false
                },
                {
                    name: "c_st_12_loop",
                    loop: true
                },
                {
                    name: "c_st_12_to_st_13",
                    loop: false
                },
                {
                    name: "c_st_13_coin",
                    loop: false
                },
                {
                    name: "c_st_13_coin_rain",
                    loop: false
                },
                {
                    name: "c_st_13_loop",
                    loop: true
                },
                {
                    name: "c_st_13_to_st_14",
                    loop: false
                },
                {
                    name: "c_st_14_coin",
                    loop: false
                },
                {
                    name: "c_st_14_coin_rain",
                    loop: false
                },
                {
                    name: "c_st_14_loop",
                    loop: true
                },
                {
                    name: "c_st_14_to_st_15",
                    loop: false
                },
                {
                    name: "c_st_15_coin",
                    loop: false
                },
                {
                    name: "c_st_15_coin_rain",
                    loop: false
                },
                {
                    name: "c_st_15_loop",
                    loop: true
                },
                {
                    name: "c_st_15_to_st_16",
                    loop: false
                },
                {
                    name: "c_st_16_coin",
                    loop: false
                },
                {
                    name: "c_st_16_coin_rain",
                    loop: false
                },
                {
                    name: "c_st_16_loop",
                    loop: true
                },

            ],
            // containerSize: 1.5,
            visible: true,
            defaultState: "",
            playDefault: false,
            // forceRepositionContainer: false,
            chainingStates: [
                {
                    name: "transition_2",
                    entryPoint: "c_st_1_to_st_2",
                    hasLoopStateOnComplete: true,
                    hasStaticStateOnComplete: false,
                    hideOnComplete: false,
                    loopStateOnComplete: "c_st_2_loop",
                    loop: false,
                    states: ["c_st_1_to_st_2", "c_st_2_loop"]
                },
                {
                    name: "transition_3",
                    entryPoint: "c_st_2_to_st_3",
                    hasLoopStateOnComplete: true,
                    hasStaticStateOnComplete: false,
                    hideOnComplete: false,
                    loopStateOnComplete: "c_st_3_loop",
                    loop: false,
                    states: ["c_st_2_to_st_3", "c_st_3_loop"]
                },
                {
                    name: "transition_4",
                    entryPoint: "c_st_3_to_st_4",
                    hasLoopStateOnComplete: true,
                    hasStaticStateOnComplete: false,
                    hideOnComplete: false,
                    loopStateOnComplete: "c_st_4_loop",
                    loop: false,
                    states: ["c_st_3_to_st_4", "c_st_4_loop"]
                },
                {
                    name: "transition_5",
                    entryPoint: "c_st_4_to_st_5",
                    hasLoopStateOnComplete: true,
                    hasStaticStateOnComplete: false,
                    hideOnComplete: false,
                    loopStateOnComplete: "c_st_5_loop",
                    loop: false,
                    states: ["c_st_4_to_st_5", "c_st_5_loop"]
                },
                {
                    name: "transition_6",
                    entryPoint: "c_st_5_to_st_6",
                    hasLoopStateOnComplete: true,
                    hasStaticStateOnComplete: false,
                    hideOnComplete: false,
                    loopStateOnComplete: "c_st_6_loop",
                    loop: false,
                    states: ["c_st_5_to_st_6", "c_st_6_loop"]
                },
                {
                    name: "transition_7",
                    entryPoint: "c_st_6_to_st_7",
                    hasLoopStateOnComplete: true,
                    hasStaticStateOnComplete: false,
                    hideOnComplete: false,
                    loopStateOnComplete: "c_st_7_loop",
                    loop: false,
                    states: ["c_st_6_to_st_7", "c_st_7_loop"]
                },
                {
                    name: "transition_8",
                    entryPoint: "c_st_7_to_st_8",
                    hasLoopStateOnComplete: true,
                    hasStaticStateOnComplete: false,
                    hideOnComplete: false,
                    loopStateOnComplete: "c_st_8_loop",
                    loop: false,
                    states: ["c_st_7_to_st_8", "c_st_8_loop"]
                },
                {
                    name: "transition_9",
                    entryPoint: "c_st_8_to_st_9",
                    hasLoopStateOnComplete: true,
                    hasStaticStateOnComplete: false,
                    hideOnComplete: false,
                    loopStateOnComplete: "c_st_9_loop",
                    loop: false,
                    states: ["c_st_8_to_st_9", "c_st_9_loop"]
                },
                {
                    name: "transition_10",
                    entryPoint: "c_st_9_to_st_10",
                    hasLoopStateOnComplete: true,
                    hasStaticStateOnComplete: false,
                    hideOnComplete: false,
                    loopStateOnComplete: "c_st_10_loop",
                    loop: false,
                    states: ["c_st_9_to_st_10", "c_st_10_loop"]
                },
                {
                    name: "transition_11",
                    entryPoint: "c_st_10_to_st_11",
                    hasLoopStateOnComplete: true,
                    hasStaticStateOnComplete: false,
                    hideOnComplete: false,
                    loopStateOnComplete: "c_st_11_loop",
                    loop: false,
                    states: ["c_st_10_to_st_11", "c_st_11_loop"]
                },
                {
                    name: "transition_12",
                    entryPoint: "c_st_11_to_st_12",
                    hasLoopStateOnComplete: true,
                    hasStaticStateOnComplete: false,
                    hideOnComplete: false,
                    loopStateOnComplete: "c_st_12_loop",
                    loop: false,
                    states: ["c_st_11_to_st_12", "c_st_12_loop"]
                },
                {
                    name: "transition_13",
                    entryPoint: "c_st_12_to_st_13",
                    hasLoopStateOnComplete: true,
                    hasStaticStateOnComplete: false,
                    hideOnComplete: false,
                    loopStateOnComplete: "c_st_13_loop",
                    loop: false,
                    states: ["c_st_12_to_st_13", "c_st_13_loop"]
                },
                {
                    name: "transition_14",
                    entryPoint: "c_st_13_to_st_14",
                    hasLoopStateOnComplete: true,
                    hasStaticStateOnComplete: false,
                    hideOnComplete: false,
                    loopStateOnComplete: "c_st_14_loop",
                    loop: false,
                    states: ["c_st_13_to_st_14", "c_st_14_loop"]
                },
                {
                    name: "transition_15",
                    entryPoint: "c_st_14_to_st_15",
                    hasLoopStateOnComplete: true,
                    hasStaticStateOnComplete: false,
                    hideOnComplete: false,
                    loopStateOnComplete: "c_st_15_loop",
                    loop: false,
                    states: ["c_st_14_to_st_15", "c_st_15_loop"]
                },
                {
                    name: "transition_16",
                    entryPoint: "c_st_15_to_st_16",
                    hasLoopStateOnComplete: true,
                    hasStaticStateOnComplete: false,
                    hideOnComplete: false,
                    loopStateOnComplete: "c_st_16_loop",
                    loop: false,
                    states: ["c_st_15_to_st_16", "c_st_16_loop"]
                },
            ]
        },
        {
            name: "animation",
            hasSkins: false,
            states: [
                {
                    name: "main_loop",
                    loop: true
                },
                {
                    name: "freespin_loop",
                    loop: true
                },
                {
                    name: "main_to_freespin",
                    loop: false
                },
            ],
            visible: true,
            defaultState: "main_loop",
            playDefault: true,
            forceRepositionContainer: false,
        },
        {
            name: "coinRain",
            hasSkins: false,
            states: [
                {
                    name: "rain_1",
                    loop: false
                },
                {
                    name: "rain_2",
                    loop: false
                },
                {
                    name: "rain_3",
                    loop: false
                },
                {
                    name: "rain_4",
                    loop: false
                },
                {
                    name: "rain_5",
                    loop: false
                },
            ],
            visible: true,
            defaultState: "rain_1",
            playDefault: false,
            // forceRepositionContainer: false,
            containerSize: 1.2,
        },
        {
            name: "frame_anticipation",
            hasSkins: false,
            states: [
                {
                    name: "start",
                    loop: false
                },
                {
                    name: "idle",
                    loop: true
                },
                {
                    name: "idle_pt",
                    loop: true
                },
                {
                    name: "loop",
                    loop: true
                },
                {
                    name: "end",
                    loop: false
                },
                {
                    name: "start_pt",
                    loop: false
                },
                {
                    name: "loop_pt",
                    loop: true
                },
                {
                    name: "end_pt",
                    loop: false
                },
            ],
            visible: true,
            defaultState: "idle",
            playDefault: true,
            forceRepositionContainer: true,
            containerSize: 1.4,
            chainingStates: [
                {
                    entryPoint: "start",
                    hasLoopStateOnComplete: true,
                    hasStaticStateOnComplete: false,
                    hideOnComplete: false,
                    loop: false,
                    loopStateOnComplete: "loop",
                    name: "show",
                    states: ["start", "loop"],
                },
                {
                    entryPoint: "start_pt",
                    hasLoopStateOnComplete: true,
                    hasStaticStateOnComplete: false,
                    hideOnComplete: false,
                    loop: false,
                    loopStateOnComplete: "loop_pt",
                    name: "show_pt",
                    states: ["start_pt", "loop_pt"],
                },
            ]
        },
        {
            name: "fsIntroOutro",
            hasSkins: false,
            states: [
                {
                    name: "intro_end",
                    loop: false
                },
                {
                    name: "intro_loop",
                    loop: true
                },
                {
                    name: "intro_start",
                    loop: false
                },
                {
                    name: "outro_end",
                    loop: false
                },

                {
                    name: "outro_loop",
                    loop: true
                },
                {
                    name: "outro_start",
                    loop: false
                },
            ],
            visible: true,
            defaultState: "start_intro",
            playDefault: false,
            forceRepositionContainer: false,
            chainingStates: [
                {
                    entryPoint: "intro_start",
                    hasLoopStateOnComplete: true,
                    hasStaticStateOnComplete: false,
                    hideOnComplete: false,
                    loop: false,
                    loopStateOnComplete: "intro_loop",
                    name: "intro",
                    states: ["intro_start", "intro_loop"],
                },
                {
                    entryPoint: "outro_start",
                    hasLoopStateOnComplete: true,
                    hasStaticStateOnComplete: false,
                    hideOnComplete: false,
                    loop: false,
                    loopStateOnComplete: "outro_loop",
                    name: "outro",
                    states: ["outro_start", "outro_loop"],
                },
            ]
        },
    ];
}

export default new SpineAnimationsConfig()
